/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CRSFDesiredPolicyFieldsInput } from './CRSFDesiredPolicyFieldsInput';
import {
    CRSFDesiredPolicyFieldsInputFromJSON,
    CRSFDesiredPolicyFieldsInputFromJSONTyped,
    CRSFDesiredPolicyFieldsInputToJSON,
} from './CRSFDesiredPolicyFieldsInput';
import type { CRSFLocale } from './CRSFLocale';
import {
    CRSFLocaleFromJSON,
    CRSFLocaleFromJSONTyped,
    CRSFLocaleToJSON,
} from './CRSFLocale';

/**
 * The secondary scan trigger.
 * @export
 * @interface CRSFTrigger
 */
export interface CRSFTrigger {
    /**
     * 
     * @type {string}
     * @memberof CRSFTrigger
     */
    account_uuid?: string;
    /**
     * 
     * @type {string}
     * @memberof CRSFTrigger
     */
    cobranded?: string;
    /**
     * 
     * @type {CRSFDesiredPolicyFieldsInput}
     * @memberof CRSFTrigger
     */
    desired_policy_fields?: CRSFDesiredPolicyFieldsInput;
    /**
     * 
     * @type {string}
     * @memberof CRSFTrigger
     */
    desired_policy_uuid?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CRSFTrigger
     */
    dry_run?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CRSFTrigger
     */
    force?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CRSFTrigger
     */
    issue_key: string;
    /**
     * 
     * @type {CRSFLocale}
     * @memberof CRSFTrigger
     */
    locale?: CRSFLocale;
    /**
     * 
     * @type {Array<string>}
     * @memberof CRSFTrigger
     */
    new_domains_at_bind?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CRSFTrigger
     */
    renewal_of_uuid?: string;
    /**
     * 
     * @type {string}
     * @memberof CRSFTrigger
     */
    request_origin?: string;
    /**
     * 
     * @type {string}
     * @memberof CRSFTrigger
     */
    retained_from_uuid?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CRSFTrigger
     */
    scan_web_sev2_force?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CRSFTrigger
     */
    signal_id?: number;
    /**
     * 
     * @type {string}
     * @memberof CRSFTrigger
     */
    user?: string;
}

/**
 * Check if a given object implements the CRSFTrigger interface.
 */
export function instanceOfCRSFTrigger(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "issue_key" in value;

    return isInstance;
}

export function CRSFTriggerFromJSON(json: any): CRSFTrigger {
    return CRSFTriggerFromJSONTyped(json, false);
}

export function CRSFTriggerFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFTrigger {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'account_uuid': !exists(json, 'account_uuid') ? undefined : json['account_uuid'],
        'cobranded': !exists(json, 'cobranded') ? undefined : json['cobranded'],
        'desired_policy_fields': !exists(json, 'desired_policy_fields') ? undefined : CRSFDesiredPolicyFieldsInputFromJSON(json['desired_policy_fields']),
        'desired_policy_uuid': !exists(json, 'desired_policy_uuid') ? undefined : json['desired_policy_uuid'],
        'dry_run': !exists(json, 'dry_run') ? undefined : json['dry_run'],
        'force': !exists(json, 'force') ? undefined : json['force'],
        'issue_key': json['issue_key'],
        'locale': !exists(json, 'locale') ? undefined : CRSFLocaleFromJSON(json['locale']),
        'new_domains_at_bind': !exists(json, 'new_domains_at_bind') ? undefined : json['new_domains_at_bind'],
        'renewal_of_uuid': !exists(json, 'renewal_of_uuid') ? undefined : json['renewal_of_uuid'],
        'request_origin': !exists(json, 'request_origin') ? undefined : json['request_origin'],
        'retained_from_uuid': !exists(json, 'retained_from_uuid') ? undefined : json['retained_from_uuid'],
        'scan_web_sev2_force': !exists(json, 'scan_web_sev2_force') ? undefined : json['scan_web_sev2_force'],
        'signal_id': !exists(json, 'signal_id') ? undefined : json['signal_id'],
        'user': !exists(json, 'user') ? undefined : json['user'],
    };
}

export function CRSFTriggerToJSON(value?: CRSFTrigger | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'account_uuid': value.account_uuid,
        'cobranded': value.cobranded,
        'desired_policy_fields': CRSFDesiredPolicyFieldsInputToJSON(value.desired_policy_fields),
        'desired_policy_uuid': value.desired_policy_uuid,
        'dry_run': value.dry_run,
        'force': value.force,
        'issue_key': value.issue_key,
        'locale': CRSFLocaleToJSON(value.locale),
        'new_domains_at_bind': value.new_domains_at_bind,
        'renewal_of_uuid': value.renewal_of_uuid,
        'request_origin': value.request_origin,
        'retained_from_uuid': value.retained_from_uuid,
        'scan_web_sev2_force': value.scan_web_sev2_force,
        'signal_id': value.signal_id,
        'user': value.user,
    };
}

